import React from 'react'
import { SDKContainerStyle } from '_themes/default/components/styled/sdk-container'

const SDKContainer = ({ className, children }) => {
  return <SDKContainerStyle className={className}>{children}</SDKContainerStyle>
}

export default SDKContainer
